var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 20.0003C21 20.2655 20.8946 20.5199 20.7071 20.7074C20.5196 20.8949 20.2652 21.0003 20 21.0003H4C3.73478 21.0003 3.48043 20.8949 3.29289 20.7074C3.10536 20.5199 3 20.2655 3 20.0003V9.4903C2.99989 9.33791 3.03462 9.18751 3.10152 9.0506C3.16841 8.91368 3.26572 8.79386 3.386 8.7003L11.386 2.4773C11.5615 2.34074 11.7776 2.2666 12 2.2666C12.2224 2.2666 12.4385 2.34074 12.614 2.4773L20.614 8.7003C20.7343 8.79386 20.8316 8.91368 20.8985 9.0506C20.9654 9.18751 21.0001 9.33791 21 9.4903V20.0003Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.5c24ce0c36e171efe1a52b76fd870d13.svg";
export { ForwardRef as ReactComponent };